import { FC } from 'react';
import { MenuItemWrapper, MenuDetail, MenuWithCondiments, Name, Amount } from './index.view';
import { Price } from '../../index.view';
import { MenuItemInterface } from 'utils/types/oraclePayment/MenuItem';
import { currencyFormat } from 'utils/number';
import SubMenu from '../SubMenu';
import useViewModel from './viewModel';
import { truncateCancelName } from '@fanz-common-frontend';
interface MenuItemProps {
  menuItem: MenuItemInterface;
  width?: string;
}

const MenuItem: FC<MenuItemProps> = ({ menuItem }) => {
  const { subItems, quantity, total, nameOriginal, canceled } = menuItem;
  const { isShowCondiments, showCondiments } = useViewModel({ subItems });

  return (
    <MenuItemWrapper onClick={showCondiments}>
      <MenuDetail>
        <Amount>{`${quantity}x`}</Amount>
      </MenuDetail>
      <MenuWithCondiments>
        <MenuDetail alignment="space-between">
          <Name>{canceled ? truncateCancelName(nameOriginal) : nameOriginal}</Name>
          <Price>{currencyFormat(total)}</Price>
        </MenuDetail>
        <SubMenu isShow={isShowCondiments} subMenus={subItems || []} />
      </MenuWithCondiments>
    </MenuItemWrapper>
  );
};

export default MenuItem;
